// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalBody_root__O15Q_","children":"ModalBody_children__6CaEF","useFade-fadeIn":"ModalBody_useFade-fadeIn__NxPWB","useFade-fadeOut":"ModalBody_useFade-fadeOut__spP6g"};